import { request } from './config/utils'

import { Params } from '../../constants'

export function historyPostRequest(params) {

    return request('post', params, Params.HISTORY_POST)
}